import * as Yup from 'yup'
import { LIST_ITEM_OPTION, OPTION_NEW_LIST_ITEM } from './fields'

export const getConditionalNewListItemValidation = validationObject => {
  const result = {}
  Object.keys(validationObject).forEach(key => {
    result[key] = Yup.mixed().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () => validationObject[key],
      otherwise: () => Yup.mixed().notRequired()
    })
  })
  return result
}
